module.exports = __webpack_public_path__ + "media/application/images/icons/printer-e2dad4063880ea855abc33898380d0b4.svg";